import React, { useState } from "react";
import { useAppSelector } from "../../../context-store";
import { useHistory } from "react-router";
import { useForm, Controller } from "react-hook-form";
import toasterUtils from "../../../utils/toaster-utils";
import InterviewerService from '../../../services/interviewer/interviewer-service';
import InterviewRatingModel from "../../../models/interviewer/response/InterviewRatingModel";
import dateUtils from "../../../utils/date-utils";
import "../../../landing-pages/Interviewer/rating.css";
import { RoleEnum } from "../../../models/enums/RoleEnum";
import modalUtils from "../../../utils/modal-utils";
import { FORM_SELECT_RULE, OBJECT_DESCRIPTION_RULE_REQUIRED, OBJECT_DESCRIPTION_RULE_RATING, OBJECT_DESCRIPTION_RULE_TOTAL_RATING } from "../../../utils/validation-utils";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button as MuiButton, FormControl, InputLabel, Select, MenuItem, FormHelperText, TextField, Checkbox, FormControlLabel, Button, FormLabel, RadioGroup, Radio } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface RateInterviewProps {
    objRateInterview: InterviewRatingModel;
}

const RateInterviewComponent = (props: RateInterviewProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const history = useHistory();
    const [rating] = useState<number[]>([1, 2, 3, 4, 5]);
    const [expanded, setExpanded] = useState<false | "tech" | "soft">("tech");
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
    } = useForm<InterviewRatingModel>({
        mode: "onChange",
        defaultValues: props.objRateInterview
    });

    const onSubmit = (formData: InterviewRatingModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.isGenuine = String(formData.isGenuine) === "yes" ? true : false;
        formData.recommendForNextRound = String(formData.recommendForNextRound) === "yes" ? true : false;
        let ratingZero = formData.technicalSkillRating.find(x => x.rating === 0);
        let softSkillZero = formData.softSkillRating.find(x => x.rating === 0);
        if (ratingZero || softSkillZero) {
            toasterUtils.showError("Rating should not be 0.");
        } else {
            modalUtils.showLoader();
            InterviewerService.updateInterviewRating(formData).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                setTimeout(() => {
                    if (loggedInUser && loggedInUser.roleId === RoleEnum.Interviewer.toString()) {
                        history.push("/interviewer-dashboard");
                    } else if (loggedInUser && (loggedInUser.roleId === RoleEnum.Administrator.toString() || loggedInUser.roleId === RoleEnum.IAIRecruiter.toString())) {
                        history.push("/admin-dashboard");
                    } else {
                        history.push("/");
                    }
                }, 2000);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const clearRating = () => {
        if (loggedInUser && loggedInUser.roleId === RoleEnum.Interviewer.toString()) {
            history.push("/interviewer-dashboard");
        } else if (loggedInUser && (loggedInUser.roleId === RoleEnum.Administrator.toString() || loggedInUser.roleId === RoleEnum.IAIRecruiter.toString())) {
            history.push("/admin-dashboard");
        } else {
            history.push("/");
        }
    };

    const handleAccordionChange = (panel: "tech" | "soft") => (_: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-3">Candidate Name :</div>
                        <div className="col-md-3"><span className="rating-value-lable">{props.objRateInterview.candidateName}</span></div>
                        <div className="col-md-3">Interview Date & Time : </div>
                        <div className="col-md-3"><span className="rating-value-lable">{dateUtils.getFormattedDateFromDate(props.objRateInterview.interviewDate)} - {props.objRateInterview.timeSlotName}</span></div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">Primary Skill :</div>
                        <div className="col-md-3"><span className="rating-value-lable">{props.objRateInterview.primarySkillName}</span></div>
                        <div className="col-md-3">Mobile No :</div>
                        <div className="col-md-3"><span className="rating-value-lable">{props.objRateInterview.mobileNumber}</span></div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">Candidate Email :</div>
                        <div className="col-md-3"><span className="rating-value-lable">{props.objRateInterview.mobileNumber}</span></div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="rating-tip-header">Rating Tips/Interpretation</h3>
                            <p className="rating-tips">1. Know the subject but no good knowledge, need to learn.</p>
                            <p className="rating-tips">2. Know the subject, have knowledge but no good working exp.</p>
                            <p className="rating-tips">3. Have the knowledge and can work independently.</p>
                            <p className="rating-tips">4. Can work and Guide the team also to work.</p>
                            <p className="rating-tips">5. Exceptionally talented in this and is an asset to the team and to organization.</p>
                        </div>
                        <div className="col-md-6">
                            <h3 className="rating-tip-header">Key Responsibilities</h3>
                            <p></p>
                        </div>
                    </div>
                    <div className="row">
                        <Accordion expanded={expanded === "tech"} onChange={handleAccordionChange("tech")}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h6">TECHNICAL RATING</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {props.objRateInterview.technicalSkillRating.map((skill, index) => (
                                    <div key={index}>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                                    {skill.secondarySkillName}
                                                </Typography>
                                            </div>
                                            <div className="col-md-3">
                                                <Controller name={`technicalSkillRating.${index}.rating`} control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                                    render={({ field }) => (
                                                        <FormControl fullWidth margin="normal" error={!!errors?.technicalSkillRating?.[index]?.rating}>
                                                            <InputLabel required>Rating</InputLabel>
                                                            <Select {...field} label="Rating" size="small">
                                                                <MenuItem value={0}>Select Rating</MenuItem>
                                                                {rating.map((type, idx) => (
                                                                    <MenuItem key={idx} value={type}>
                                                                        {type}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <FormHelperText>
                                                                {errors?.technicalSkillRating?.[index]?.rating?.message}
                                                            </FormHelperText>
                                                        </FormControl>
                                                    )}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                {skill.isCommentsRequired &&
                                                    <FormControl fullWidth margin="normal" error={!!errors?.technicalSkillRating?.[index]?.comments}>
                                                        <TextField label="Interview Feedback" multiline rows={2} size="small" placeholder="Min 50 and Max 200 characters"
                                                            {...register(`technicalSkillRating.${index}.comments`, { required: skill.isCommentsRequired, ...OBJECT_DESCRIPTION_RULE_RATING })} required={skill.isCommentsRequired}
                                                            error={!!errors?.technicalSkillRating?.[index]?.comments} helperText={!!errors?.technicalSkillRating?.[index]?.comments} autoComplete="off" />
                                                    </FormControl>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === "soft"} onChange={handleAccordionChange("soft")}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h6">SOFT SKILL RATING</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {props.objRateInterview.softSkillRating.map((skill, index) => (
                                    <div className="row" key={index}>
                                        <div className="col-md-3">
                                            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                                {skill.softSkillName}
                                            </Typography>
                                        </div>
                                        <div className="col-md-3">
                                            <Controller name={`softSkillRating.${index}.rating`} control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                                render={({ field }) => (
                                                    <FormControl fullWidth margin="normal" error={!!errors?.softSkillRating?.[index]?.rating}>
                                                        <InputLabel required>Rating</InputLabel>
                                                        <Select {...field} label="Rating" size="small">
                                                            <MenuItem value={0}>Select Rating</MenuItem>
                                                            {rating.map((type, idx) => (
                                                                <MenuItem key={idx} value={type}>
                                                                    {type}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText>
                                                            {errors?.softSkillRating?.[index]?.rating?.message}
                                                        </FormHelperText>
                                                    </FormControl>
                                                )}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <FormControl fullWidth margin="normal" error={!!errors?.softSkillRating?.[index]?.comments}>
                                                <TextField label="Interview Feedback" multiline rows={2} size="small" placeholder="Min 50 and Max 200 characters"
                                                    {...register(`softSkillRating.${index}.comments`, { required: true, ...OBJECT_DESCRIPTION_RULE_REQUIRED })} required
                                                    error={!!errors?.softSkillRating?.[index]?.comments} helperText={!!errors?.softSkillRating?.[index]?.comments} autoComplete="off" />
                                            </FormControl>
                                        </div>
                                    </div>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    <div className="row">
                        <div className="col-md-12 padding-0">
                            <FormControl fullWidth margin="normal" error={!!errors?.interviewerComments}>
                                <TextField label="Comments" multiline rows={2} size="small" placeholder="Min 100 and Max 500 characters"
                                    {...register("interviewerComments", { required: true, ...OBJECT_DESCRIPTION_RULE_TOTAL_RATING })} required
                                    error={!!errors?.interviewerComments} helperText={!!errors?.interviewerComments} autoComplete="off" />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Controller name="isGenuine" control={control} defaultValue={undefined} rules={{ required: "Please select Yes or No" }}
                                render={({ field, fieldState }) => (
                                    <FormControl fullWidth margin="normal" required error={!!fieldState.error}                                    >
                                        <FormLabel required sx={{
                                            "& .MuiFormLabel-asterisk": {
                                                color: "red"
                                            }
                                        }}>Is Genuine</FormLabel>
                                        <RadioGroup row {...field} value={field.value ?? ""} onChange={(e) => field.onChange(e.target.value)}                                        >
                                            <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
                                            <FormControlLabel value="no" control={<Radio size="small" />} label="No" />
                                        </RadioGroup>
                                        <FormHelperText>
                                            {fieldState.error?.message}
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <Controller name="recommendForNextRound" control={control} defaultValue={undefined} rules={{ required: "Please select Yes or No" }}
                                render={({ field, fieldState }) => (
                                    <FormControl fullWidth margin="normal" required error={!!fieldState.error}                                    >
                                        <FormLabel required sx={{
                                            "& .MuiFormLabel-asterisk": {
                                                color: "red"
                                            }
                                        }}>Recommend For Next Round</FormLabel>
                                        <RadioGroup row {...field} value={field.value ?? ""} onChange={(e) => field.onChange(e.target.value)}                                        >
                                            <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
                                            <FormControlLabel value="no" control={<Radio size="small" />} label="No" />
                                        </RadioGroup>
                                        <FormHelperText>
                                            {fieldState.error?.message}
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-9"></div>
                        <div className="col-md-3">
                            <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                Save
                            </Button>
                            <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={clearRating}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default RateInterviewComponent;